#import "../timeZone/timeZoneInfo.gql"

fragment siteInfo on Site {
  id
  externalId
  externalAccountUuid
  lastSyncedAt
  lineOrder
  createdAt
  updatedAt
  name
  settings
  timeZoneDisplayName
  startOfDay
  timeZone {
    ...timeZoneInfo
  }
  company {
    id
    name
  }
}
